// extracted by mini-css-extract-plugin
module.exports = {"swiperSlide":"Slide_swiperSlide__1edtz","row":"Slide_row__303r9","swiper-slide":"Slide_swiper-slide__3k-gG"};